import React from 'react'

/**
 * 👥 Секция помощника — toggle + тарифы помощника + влияние на основного.
 */
export default function HelperSection({ settings, onChange }) {
  const enabled = settings.enableHelpers !== false

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {/* Toggle включения */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '12px 16px', background: 'var(--surface-hover)', borderRadius: '12px',
      }}>
        <div>
          <div style={{ fontWeight: 600, fontSize: '14px', color: 'var(--text-primary)' }}>
            Разрешить помощников на ПВЗ
          </div>
          <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginTop: '2px' }}>
            Сотрудники смогут вызывать помощника на смену
          </div>
        </div>
        <label style={{ position: 'relative', display: 'inline-block', width: 48, height: 26, cursor: 'pointer', flexShrink: 0 }}>
          <input
            type="checkbox"
            checked={enabled}
            onChange={(e) => onChange('enableHelpers', e.target.checked)}
            style={{ opacity: 0, width: 0, height: 0 }}
          />
          <span style={{
            position: 'absolute', cursor: 'pointer', top: 0, left: 0, right: 0, bottom: 0,
            background: enabled ? 'var(--wb-primary)' : 'var(--surface-border)',
            borderRadius: 26, transition: 'all 0.3s ease',
          }}>
            <span style={{
              position: 'absolute', height: 20, width: 20,
              left: enabled ? 24 : 3, bottom: 3,
              background: 'white', borderRadius: '50%',
              transition: 'all 0.3s ease', boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
            }}></span>
          </span>
        </label>
      </div>

      {/* Контент — скрывается если выключено */}
      <div style={{
        opacity: enabled ? 1 : 0.4,
        pointerEvents: enabled ? 'auto' : 'none',
        transition: 'opacity 0.3s ease',
      }}>
        {/* Оплата помощника */}
        <div style={{
          padding: '14px 16px', background: 'var(--surface-hover)',
          borderRadius: '12px', marginBottom: '14px',
        }}>
          <div style={{ fontSize: '13px', fontWeight: 700, color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>
            Оплата помощника
          </div>
          <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '14px' }}>
            Сколько получает сам помощник за работу
          </div>
          <div className="salary-config-grid">
            <div className="salary-config-item">
              <div className="salary-config-icon"></div>
              <div className="salary-config-field">
                <label>Почасовая ставка</label>
                <div className="salary-config-input-wrapper">
                  <input className="input" type="number" min="0"
                    value={settings.helperHourlyRate === 0 || settings.helperHourlyRate === '0' ? '' : settings.helperHourlyRate}
                    placeholder="0"
                    onChange={(e) => onChange('helperHourlyRate', e.target.value)}
                  />
                  <span className="salary-config-unit">₽ / час</span>
                </div>
              </div>
            </div>
            <div className="salary-config-item">
              <div className="salary-config-icon"></div>
              <div className="salary-config-field">
                <label>За принятый товар</label>
                <div className="salary-config-input-wrapper">
                  <input className="input" type="number" min="0" step="0.1"
                    value={settings.helperOwnBonusPerAccepted === 0 || settings.helperOwnBonusPerAccepted === '0' ? '' : (settings.helperOwnBonusPerAccepted || '')}
                    placeholder="0"
                    onChange={(e) => onChange('helperOwnBonusPerAccepted', e.target.value)}
                  />
                  <span className="salary-config-unit">₽ / шт</span>
                </div>
              </div>
            </div>
            <div className="salary-config-item">
              <div className="salary-config-icon"></div>
              <div className="salary-config-field">
                <label>За выданный товар</label>
                <div className="salary-config-input-wrapper">
                  <input className="input" type="number" min="0" step="0.1"
                    value={settings.helperOwnBonusPerIssued === 0 || settings.helperOwnBonusPerIssued === '0' ? '' : (settings.helperOwnBonusPerIssued || '')}
                    placeholder="0"
                    onChange={(e) => onChange('helperOwnBonusPerIssued', e.target.value)}
                  />
                  <span className="salary-config-unit">₽ / шт</span>
                </div>
              </div>
            </div>
            <div className="salary-config-item">
              <div className="salary-config-icon"></div>
              <div className="salary-config-field">
                <label>За возврат товара</label>
                <div className="salary-config-input-wrapper">
                  <input className="input" type="number" min="0" step="0.1"
                    value={settings.helperOwnBonusPerReturned === 0 || settings.helperOwnBonusPerReturned === '0' ? '' : (settings.helperOwnBonusPerReturned || '')}
                    placeholder="0"
                    onChange={(e) => onChange('helperOwnBonusPerReturned', e.target.value)}
                  />
                  <span className="salary-config-unit">₽ / шт</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Влияние на основного сотрудника */}
        <div style={{
          padding: '14px 16px', background: 'var(--surface-hover)',
          borderRadius: '12px',
        }}>
          <div style={{ fontSize: '13px', fontWeight: 700, color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>
            Тарифы основного в смене с помощником
          </div>
          <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '14px' }}>
            Как меняются тарифы основного сотрудника когда он работает вместе с помощником. Если пусто — используются базовые тарифы.
          </div>
          <div className="salary-config-grid">
            <div className="salary-config-item">
              <div className="salary-config-icon"></div>
              <div className="salary-config-field">
                <label>Удержание с основного</label>
                <div className="salary-config-input-wrapper">
                  <input className="input" type="number" min="0" max="100"
                    value={settings.helperDeductionPercent === 0 || settings.helperDeductionPercent === '0' ? '' : settings.helperDeductionPercent}
                    placeholder="0"
                    onChange={(e) => onChange('helperDeductionPercent', e.target.value)}
                  />
                  <span className="salary-config-unit">% от ЗП пом.</span>
                </div>
              </div>
            </div>
            <div className="salary-config-item">
              <div className="salary-config-icon"></div>
              <div className="salary-config-field">
                <label>За принятый товар</label>
                <div className="salary-config-input-wrapper">
                  <input className="input" type="number" min="0" step="0.1"
                    value={settings.helperBonusPerAccepted === 0 || settings.helperBonusPerAccepted === '0' ? '' : settings.helperBonusPerAccepted}
                    onChange={(e) => onChange('helperBonusPerAccepted', e.target.value)}
                    placeholder="Как в базе"
                  />
                  <span className="salary-config-unit">₽ / шт</span>
                </div>
              </div>
            </div>
            <div className="salary-config-item">
              <div className="salary-config-icon"></div>
              <div className="salary-config-field">
                <label>За выданный товар</label>
                <div className="salary-config-input-wrapper">
                  <input className="input" type="number" min="0" step="0.1"
                    value={settings.helperBonusPerIssued === 0 || settings.helperBonusPerIssued === '0' ? '' : settings.helperBonusPerIssued}
                    onChange={(e) => onChange('helperBonusPerIssued', e.target.value)}
                    placeholder="Как в базе"
                  />
                  <span className="salary-config-unit">₽ / шт</span>
                </div>
              </div>
            </div>
            <div className="salary-config-item">
              <div className="salary-config-icon"></div>
              <div className="salary-config-field">
                <label>За возврат товара</label>
                <div className="salary-config-input-wrapper">
                  <input className="input" type="number" min="0" step="0.1"
                    value={settings.helperBonusPerReturned === 0 || settings.helperBonusPerReturned === '0' ? '' : settings.helperBonusPerReturned}
                    onChange={(e) => onChange('helperBonusPerReturned', e.target.value)}
                    placeholder="Как в базе"
                  />
                  <span className="salary-config-unit">₽ / шт</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
